import React from 'react';
import { Text, Linking, StyleProp, TextStyle, Alert } from 'react-native';

const URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

interface LinkTextProps {
  children: string;
  style?: StyleProp<TextStyle>;
  linkColor?: string;
}

/**
 * Renders a string and makes any URLs inside it tappable.
 * Non-URL text keeps the style passed via `style`.
 * URL text is underlined and rendered in `linkColor`.
 */
const LinkText: React.FC<LinkTextProps> = ({ children, style, linkColor = '#4A9EFF' }) => {
  const parts = children.split(URL_REGEX);

  const handlePress = async (url: string) => {
    const normalized = url.startsWith('http') ? url : `https://${url}`;
    try {
      const canOpen = await Linking.canOpenURL(normalized);
      if (canOpen) {
        await Linking.openURL(normalized);
      } else {
        Alert.alert('Cannot open link', normalized);
      }
    } catch {
      Alert.alert('Cannot open link', normalized);
    }
  };

  return (
    <Text style={style}>
      {parts.map((part, i) => {
        if (URL_REGEX.test(part)) {
          // Reset regex lastIndex between calls (flag `g` retains state)
          URL_REGEX.lastIndex = 0;
          return (
            <Text
              key={i}
              style={{ color: linkColor, textDecorationLine: 'underline' }}
              onPress={() => handlePress(part)}
              suppressHighlighting
            >
              {part}
            </Text>
          );
        }
        URL_REGEX.lastIndex = 0;
        return <Text key={i}>{part}</Text>;
      })}
    </Text>
  );
};

export default LinkText;
